import {
  blurPrimitives,
  colorPrimitives,
  shadowPrimitives,
} from './primitives';

export const semanticTokens = {
  surface: {
    page: colorPrimitives.grey[50],
    card: '#ffffff',
    glassCard: 'rgba(255, 255, 255, 0.95)',
    overlay: 'rgba(255,255,255,0.1)',
    overlayStrong: 'rgba(255,255,255,0.2)',
    googleButton: '#ffffff',
    googleButtonHover: '#f8f9fa',
  },
  text: {
    primary: colorPrimitives.grey[900],
    secondary: colorPrimitives.grey[600],
    muted: colorPrimitives.grey[500],
    inverse: '#ffffff',
  },
  border: {
    subtle: colorPrimitives.grey[200],
    input: 'rgba(0, 0, 0, 0.23)',
    glass: 'rgba(255, 255, 255, 0.3)',
    overlay: 'rgba(255,255,255,0.2)',
    google: '#dadce0',
    googleHover: '#c6c6c6',
  },
  icon: {
    brand: colorPrimitives.primary[600],
    subdued: colorPrimitives.grey[500],
    google: '#4285F4',
    inverse: '#ffffff',
  },
  feedback: {
    errorSoft: 'linear-gradient(135deg, rgba(211, 47, 47, 0.10) 0%, rgba(255, 235, 238, 0.92) 100%)',
  },
  effect: {
    blur: blurPrimitives,
    shadow: shadowPrimitives,
  },
  gradient: {
    primaryHero: `linear-gradient(135deg, ${colorPrimitives.primary[800]} 0%, ${colorPrimitives.primary[600]} 50%, ${colorPrimitives.primary[400]} 100%)`,
    primaryAction: `linear-gradient(135deg, ${colorPrimitives.primary[600]}, ${colorPrimitives.primary[800]})`,
    primaryActionHover: `linear-gradient(135deg, ${colorPrimitives.primary[800]}, ${colorPrimitives.primary[600]})`,
  },
} as const;